import { useParams } from "react-router-dom";
import VerificationLayout from "../component/layout/VerificationLayout.component";
import { useVerification } from "../context/Verification.context";
import { useAuth } from "../context/Auth.context";
import { useEffect } from "react";
import UserDetails from "../component/base/UserDetails.component";

import { Box } from "@mui/material";
const ApiServicePage = () => {
  const params = useParams();
  const verification = useVerification();
  const auth = useAuth();

  console.log("paramssssscustomer", params);

  useEffect(() => {}, []);

  return (
    <>
      <VerificationLayout>
       
        <UserDetails isURL={true} />
      </VerificationLayout>
    </>
  );
};

export default ApiServicePage;
